import AirplaySvg from "../icons/airplay.svg";
import { useControls } from "../providers/CoreProvider";
import { useTranslations } from "../providers/TranslationsProvider";
import { PlayerControlButtonComponent } from "./PlayerControlButton";

export const AirplayButton = ({ interactive }: { interactive: boolean }) => {
  const controls = useControls();
  const translations = useTranslations();

  if (!controls?.toggleAirplay) {
    return null;
  }
  return (
    <PlayerControlButtonComponent
      aria-label={translations("player__a11y__voice_over_airplay_button")}
      onClick={controls?.toggleAirplay}
      interactive={interactive}
      Icon={<AirplaySvg />}
      hoverText={translations("player__a11y__hover_label_airplay_button")}
    />
  );
};

export default AirplayButton;
